module.exports = __webpack_public_path__ + "img/expostyle_1251_citronnelle_green.fa8e0629.jpg";